"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeRemaining = void 0;
const date_1 = __importDefault(require("../date"));
const getTimeRemaining = (endDate) => {
    const total = endDate.valueOf() - (0, date_1.default)().valueOf();
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
    const days = Math.floor(total / (1000 * 60 * 60 * 24));
    return {
        total,
        days,
        hours,
        minutes,
        seconds,
    };
};
exports.getTimeRemaining = getTimeRemaining;
